import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import { isObject } from "@/shared/utils/typeGuards";

export const kVariations40Route = "/variations-4.0";

export interface Variations40RequestBody {
    fileKey: string;
    bpm: number;
    pitchPalette?: number[];
    complexity?: number;
    naturalness?: number;
    transposition?: number;
    seed?: number;
    secondsEnd?: number;
}

export const isVariations40RequestBody = (value: unknown): value is Variations40RequestBody =>
    isObject(value) && typeof value.fileKey === "string" && typeof value.bpm === "number";

export const kVariations40Endpoint: ApiEndpoint<Variations40RequestBody, DownloadUrlResponse> = {
    route: kVariations40Route,
    label: "Variations 4.0",
    source: "Modal",
    isEvaluationOnly: true,
    category: "SpliceGen v4.0",
    description: "Variations using the SpliceGen 4.0 model for richer harmonic expression.",
    isRequestBody: isVariations40RequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
